/**
 * When the transaction is posted to the book and impacts the booked balance.
 */
export const BOOKED = 'BOOKED'

/**
 * When the transaction is rejected.
 */
export const REJECTED = 'REJECTED'

/**
 * When the transaction is pending
 * and the amount impact the available balance.
 */
export const PENDING = 'PENDING'

/**
 * When a pending transaction is canceled
 * and the amount is released on the available balance.
 */
export const CANCELED = 'CANCELED'

/**
 * When the transaction is upcoming (scheduled credit transfer, direct debit ...).
 */
export const UPCOMING = 'UPCOMING'

/**
 * When a card authorization is released after X days
 * or fully consumed by X debits.
 */
export const RELEASED = 'RELEASED'

export const transactionStatus = Object.freeze({
  BOOKED,
  REJECTED,
  PENDING,
  CANCELED,
  UPCOMING,
  RELEASED
})
